import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ServiceNavbar from "../cpa/components/ServiceNavbar";
import "./styles/cpaafter.scss";

function Cpaafter() {
  return (
    <>
      {/* banner */}
      <div className="banner">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4, default: { ease: "linear" } }}
        >
          <img src="/cpaImg/CPA.jpg" alt="CPA Banner" loading="lazy" />
        </motion.div>

        <div className="cpabannertext dis">
          Becker
          <br />
          CPE
          <br />
          <div className="fs-1 dis">foundational</div>
        </div>
      </div>

      {/* Service Nav */}
      <ServiceNavbar />
        <title>Becker CPA 考後取照與 CPE 方案 | Becker Taiwan</title>
        <div class="becker-page">
            <section class="bk-hero">
                <div class="bk-container">
                    <p class="bk-hero__eyebrow">Becker Taiwan &nbsp;|&nbsp; 考後專屬方案</p>
                    <h1 class="bk-hero__title">Becker CPA 考後取照與 CPE 方案</h1>
                    <p class="bk-hero__subtitle">
                        通過美國 CPA 考試後，下一步：申請 Active License、完成 CPE、走向真正執業資格<br/>
                    </p>
                    <a href="https://www.beckertw.com/registration/plan?parent_id=1" class="bk-hero__cta" target="_blank">立即購買方案</a>
                </div>
            </section>

            {/* <!-- CONGRATS + WHY --> */}
            <section class="bk-section">
                <div class="bk-container">
                    <p class="bk-section__label">方案說明</p>
                    <h2 class="bk-section__heading">恭喜通過考試——但取照之路才正要開始</h2>
                    <hr class="bk-divider"/>
                    <p class="bk-section__lead">
                        通過美國 CPA 考試，是取得 CPA 專業資格的重要里程碑；但若要申請 Active License（執業會計師執照），各州仍可能要求申請者符合特定的學分、學位、工作經驗、背書人資格、SSN、應考年限或其他州別規定。
                    </p>
                    <p>
                        「Becker CPA 考後取照與 CPE 方案」專為已通過美國 CPA 考試、準備申請美國 CPA Active License 的考生設計，協助你釐清取照路徑、規劃申請步驟，並取得 Becker CPE Select 一年方案，銜接考後取照與執照維持所需的專業進修需求。
                    </p>

                    <p class="bk-section__label mb-1">對台灣考生而言，考後常見的挑戰</p>

                    <div class="bk-challenge-grid">
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">不確定應該申請哪一州的 CPA 執照</span>
                        </div>
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">不確定學分、工作經驗或考試紀錄是否符合指定州別要求</span>
                        </div>
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">身邊沒有能協助簽字背書工作經驗的美國執業會計師人選</span>
                        </div>
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">不熟悉各州 Board of Accountancy 的申請網站與文件要求</span>
                        </div>
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">需了解工作經驗驗證（work experience verification）背書流程</span>
                        </div>
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">想評估是否需要轉州（transfer）</span>
                        </div>
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">想了解通過美國 CPA 後，申請抵免台灣會計師考試的可行流程</span>
                        </div>
                        <div class="bk-challenge-item">

                            <span class="bk-challenge-item__text">不確定取得或維持執照後，CPE 應如何安排</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- FOR WHO --> */}
            <section class="bk-section bk-section--alt">
                <div class="bk-container">
                    <p class="bk-section__label">適合對象</p>
                    <h2 class="bk-section__heading">這個方案適合誰？</h2>
                    <hr class="bk-divider"/>
                    <p class="bk-section__lead">
                        本方案歡迎所有已通過美國 CPA 考試，並希望申請美國 CPA Active License、取得執業權利的考生購買。特別適合以下情境：
                    </p>
                    <div class="bk-for-who-grid">
                        <div class="bk-for-who-item">已通過美國 CPA 考試，但不確定下一步如何申請執照</div>
                        <div class="bk-for-who-item">想了解指定州別的 CPA 執照申請規定細節</div>
                        <div class="bk-for-who-item">需要確認學分、工作經驗、SSN、背書條件是否符合特定州別要求</div>
                        <div class="bk-for-who-item">需要會計師為工作經驗簽字背書、協助申請美國 CPA 執照</div>
                        <div class="bk-for-who-item">想了解轉州（transfer）流程與可能成本</div>
                        <div class="bk-for-who-item">想了解通過美國 CPA 後，申請抵免台灣會計師考試的相關流程</div>
                        <div class="bk-for-who-item">想使用 Becker CPE 課程，為後續執照申請或維持執照做準備</div>
                    </div>
                </div>
            </section>

            {/* <!-- SERVICES --> */}
            <section class="bk-section">
                <div class="bk-container">
                    <p class="bk-section__label">方案內容</p>
                    <h2 class="bk-section__heading">購買本方案，你將取得三大服務</h2>
                    <hr class="bk-divider"/>

                    <div class="bk-services">

                        {/* <!-- Service 1 --> */}
                        <div class="bk-service-card">
                            <div class="bk-service-card__header">
                                <span class="bk-service-card__num">服務一</span>
                                <h3 class="bk-service-card__title">申請執照／轉州／抵免台灣會計師考試諮詢，共三次</h3>
                            </div>
                            <div class="bk-service-card__body">
                                <p class="bk-service-card__desc">
                                    Becker Taiwan 將依你的個人狀況、指定州別與申請進度，提供考後取照相關諮詢。諮詢內容按照申請者個人需求量身安排，可能包含：
                                </p>
                                <ul class="bk-list">
                                    <li>指定州別之 CPA 執照申請規定細節說明（學分、學位、工作經驗、背書人資格、應考年限、SSN 要求）</li>
                                    <li>逐項檢查是否符合該州申請條件</li>
                                    <li>說明申請執照需準備的文件資料</li>
                                    <li>說明各州申請網站註冊、付款方式、聯繫窗口與特殊注意事項</li>
                                    <li>講解轉州（transfer）流程、可能成本與應注意事項</li>
                                    <li>視各州情況，提供推薦信範本、法規中譯本或相關參考資料</li>
                                    <li>視各州情況，提供轉介工作經驗背書 CPA 服務</li>
                                </ul>

                                <p class="bk-service-card__subheading">諮詢安排方式</p>

                                <div class="bk-consult-grid">
                                    <div class="bk-consult-card">
                                        <p class="bk-consult-card__title">關島、華盛頓、蒙大拿</p>
                                        <p class="bk-consult-card__body">
                                            「執照申請流程說明」完整影片一次 +「抵免台灣會計師考試流程說明」完整影片一次 + 三次一對一線上諮詢（每次 20 分鐘）
                                        </p>
                                    </div>
                                    <div class="bk-consult-card">
                                        <p class="bk-consult-card__title">其他所有州別</p>
                                        <p class="bk-consult-card__body">
                                            三次一對一線上諮詢（每次 50 分鐘），透過 Becker Taiwan 提供之 Google Meet 連結進行
                                        </p>
                                    </div>
                                </div>

                                <div class="bk-note-box">
                                    為保護雙方權益，諮詢開始時需開啟視訊，並依 Becker Taiwan 要求出示護照、身分證或其他可識別本人之文件，以確認諮詢者為購買者（執照申請者）本人。
                                </div>
                            </div>
                        </div>

                        {/* <!-- Service 2 --> */}
                        <div class="bk-service-card">
                            <div class="bk-service-card__header">
                                <span class="bk-service-card__num">服務二</span>
                                <h3 class="bk-service-card__title">會計師簽字背書 Work Experience Verification 協助服務，一次</h3>
                            </div>
                            <div class="bk-service-card__body">
                                <p class="bk-service-card__desc">
                                    申請美國 CPA Active License 時，許多州別會要求申請者完成工作經驗驗證或會計師背書。本方案包含一次會計師背書協助服務，由 Becker Taiwan 協助媒合或轉介一位持有美國 CPA 執照之背書人，並協助雙方交換聯絡方式。
                                </p>

                                <div class="bk-stat-badge">
                                    過去兩年內已協助逾 40 位考生完成背書媒合，全數成功取得 CPA Active License
                                </div>

                                <p class="bk-service-card__subheading">背書媒合如何啟動？</p>
                                <p class="bk-service-card__desc mb-2">
                                    購買本方案後，申請者需先預約並完成第一次或以上的顧問諮詢，由顧問協助確認申請州別、工作經驗與文件方向後，再依個人需求安排並轉介背書人。完成媒合後，後續背書相關對話、文件確認及簽署，將由申請者與背書人直接討論與負責。
                                </p>

                                <div class="bk-warning">
                                    <strong>購買前請先確認：</strong>你需具備至少一年適用之會計產業工作經驗（含會計師事務所、稅務事務所、業界財務會計、學界會計教學或研究、政府單位會計等）。購買時需上傳個人工作 CV 與美國 CPA 考試通過證明。
                                </div>
                            </div>
                        </div>

                        {/* <!-- Service 3 --> */}
                        <div class="bk-service-card">
                            <div class="bk-service-card__header">
                                <span class="bk-service-card__num">服務三</span>
                                <h3 class="bk-service-card__title">Becker CPE Select 一年方案</h3>
                            </div>
                            <div class="bk-service-card__body">
                                <p class="bk-service-card__desc">
                                    本方案包含 Becker CPE Select 一年方案使用授權。收到「購買確認信」當日起，即開通帳號。提供一年期的 CPE 課程使用權限，包含 webcast 直播課程與 on-demand 隨選課程，協助你依個人工作與生活節奏安排專業進修。
                                </p>

                                <p class="bk-service-card__subheading">NASBA 核心專業領域涵蓋</p>
                                <div class="bk-tags">
                                    <span class="bk-tag">Accounting 會計</span>
                                    <span class="bk-tag">Auditing 審計</span>
                                    <span class="bk-tag">Tax 稅務</span>
                                    <span class="bk-tag">Management Services 管理服務</span>
                                    <span class="bk-tag">Ethics 倫理</span>
                                    <span class="bk-tag">State-Specific Ethics Courses</span>
                                    <span class="bk-tag">其他產業別與專業主題課程</span>
                                </div>

                                <div class="bk-note-box mt-3" >
                                    <strong>CPE 認列提醒：</strong>不同州別、不同執照狀態、不同主管機關對 CPE 課程類別、時數、倫理課程、申報期限及可認列條件可能有不同規範。購買前及選課前，請自行確認本人所屬州別或主管機關之最新 CPE 要求，並依 <a href="https://www.becker.com/cpe/catalog/select" target="_blank">Becker CPE Catalog</a> 檢查所選課程是否適用。
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* <!-- PURCHASE FLOW --> */}
            <section class="bk-section bk-section--alt">
                <div class="bk-container">
                    <p class="bk-section__label">購買後流程</p>
                    <h2 class="bk-section__heading">五步驟，從付款到諮詢</h2>
                    <hr class="bk-divider"/>

                    <div class="bk-steps">
                        <div class="bk-step">
                            <span class="bk-step__circle">1</span>
                            <p class="bk-step__title">填寫報名表並付款</p>
                            <p class="bk-step__desc">請完整填寫報名表、上傳必要資料，並完成繳費付款。</p>
                        </div>
                        <div class="bk-step">
                            <span class="bk-step__circle">2</span>
                            <p class="bk-step__title">收到購買確認信</p>
                            <p class="bk-step__desc">清款後一個工作天內，Becker Taiwan 將為您註冊使用帳號、寄發「購買確認信」電郵。</p>
                        </div>
                        <div class="bk-step">
                            <span class="bk-step__circle">3</span>
                            <p class="bk-step__title">CPE 帳號開通</p>
                            <p class="bk-step__desc">收到「購買確認信」當日起，Becker CPE Select 帳號即開通，可立即使用。</p>
                        </div>
                        <div class="bk-step">
                            <span class="bk-step__circle">4</span>
                            <p class="bk-step__title">透過 LINE 預約顧問諮詢</p>
                            <p class="bk-step__desc">請透過 LINE 聯繫 Becker 團隊進行諮詢預約。Becker 團隊將於諮詢前確認你的需求細節，並安排合適的諮詢時間。</p>
                        </div>
                        <div class="bk-step">
                            <span class="bk-step__circle">5</span>
                            <p class="bk-step__title">完成諮詢後，依需求安排背書媒合</p>
                            <p class="bk-step__desc">經顧問協助確認申請州別、工作經驗、文件與取照路徑後，將依個人需求安排並轉介背書人進行媒合。</p>
                        </div>
                    </div>

                    <div class="bk-period-box">
                        <p class="bk-period-box__heading">方案效期說明</p>
                        <p class="bk-period-box__text">
                            本方案有效期間為一年，自完成清款並收到 Becker Taiwan 寄發之「購買確認信」當日起算。方案內所有服務（申請執照諮詢、會計師背書協助服務、Becker CPE Select）均需於有效期間內預約、開通、領取或使用。未於有效期間內使用之服務，於方案效期屆滿時自然失效，無法要求延長、轉讓、退費或其他補償。
                        </p>
                    </div>
                </div>
            </section>

            {/* <!-- PURCHASE CHECKLIST --> */}
            <section class="bk-section">
                <div class="bk-container">
                    <p class="bk-section__label">購買前準備</p>
                    <h2 class="bk-section__heading">購買本方案前，請準備以下資料</h2>
                    <hr class="bk-divider"/>

                    <ul class="bk-checklist">
                        <li>上傳本人個人工作 CV</li>
                        <li>上傳本人已通過美國 CPA 考試之證明文件</li>
                        <li>確認並聲明本人已持有至少一年之會計產業工作經驗</li>
                        <li>確認並保證所提供之全部資料、文件、聲明及上傳內容均為真實、正確、完整、有效且未經偽造、變造或冒用</li>
                    </ul>
                </div>
            </section>

            {/* <!-- FAQ --> */}
            <section class="bk-section bk-section--alt">
                <div class="bk-container">
                    <p class="bk-section__label">常見問題</p>
                    <h2 class="bk-section__heading">FAQ</h2>
                    <hr class="bk-divider"/>

                    <div class="bk-faq">

                        <div class="bk-faq-item">
                            <input type="checkbox" id="faq1"/>
                            <label class="bk-faq-item__label" for="faq1">Q1：我不是 Becker Taiwan 學員，可以購買這個方案嗎？</label>
                            <div class="bk-faq-item__body">
                                <p>可以！本方案不限 Becker Taiwan 既有學員。只要你已通過美國 CPA 考試，並希望申請美國 CPA Active License，即可購買本方案。</p>
                            </div>
                        </div>

                        <div class="bk-faq-item">
                            <input type="checkbox" id="faq2"/>
                            <label class="bk-faq-item__label" for="faq2">Q2：我已通過 CPA 考試，但還沒有工作經驗，可以購買嗎？</label>
                            <div class="bk-faq-item__body">
                                <p>本方案要求購買者本人已具備至少一年適用之會計產業工作經驗。若尚未具備相關工作經驗，後續可能無法如期完成工作經驗背書流程（work experience verification），也可能影響執照申請結果。</p>
                            </div>
                        </div>

                        <div class="bk-faq-item">
                            <input type="checkbox" id="faq3"/>
                            <label class="bk-faq-item__label" for="faq3">Q3：Becker Taiwan 會幫我代辦執照申請嗎？</label>
                            <div class="bk-faq-item__body">
                                <p>目前無提供代辦服務。本方案提供諮詢、媒合與 Becker CPE Select 使用授權，不包含代辦服務。申請文件準備、送件、補件、繳費、官方往來及申請結果，皆由申請者自行負責。</p>
                            </div>
                        </div>

                        <div class="bk-faq-item">
                            <input type="checkbox" id="faq4"/>
                            <label class="bk-faq-item__label" for="faq4">Q4：會計師背書服務是否保證一定簽名？</label>
                            <div class="bk-faq-item__body">
                                <p>Becker Taiwan 將協助媒合或轉介持有美國 CPA 執照之背書人，但背書人仍會依其專業判斷、州別規定、倫理規範與個人風險控管要求，決定是否進行背書及是否簽署。過去 2 年內，Becker Taiwan 已成功轉介媒合逾 40 位 CPA 學員，全數成功取得 CPA Active License。</p>
                            </div>
                        </div>

                        <div class="bk-faq-item">
                            <input type="checkbox" id="faq5"/>
                            <label class="bk-faq-item__label" for="faq5">Q5：三次諮詢一定要全部使用完嗎？</label>
                            <div class="bk-faq-item__body">
                                <p>不需要。你可以依個人申請進度與需求，在方案有效期間內預約使用。未使用完畢之諮詢次數，將於方案效期屆滿時自然失效，無法折現、退費、展延、轉讓或補償。</p>
                            </div>
                        </div>

                        <div class="bk-faq-item">
                            <input type="checkbox" id="faq6"/>
                            <label class="bk-faq-item__label" for="faq6">Q6：購買後多久會收到確認信？CPE 帳號何時開通？</label>
                            <div class="bk-faq-item__body">
                                <p>清款後一個工作天內，Becker Taiwan 將寄發「購買確認信」。收到「購買確認信」當日起，即開通 Becker CPE Select 帳號。</p>
                            </div>
                        </div>

                        <div class="bk-faq-item">
                            <input type="checkbox" id="faq7"/>
                            <label class="bk-faq-item__label" for="faq7">Q7：CPE Select 的課程一定能被我的州別認列嗎？</label>
                            <div class="bk-faq-item__body">
                                <p>不同州別、不同執照狀態、不同主管機關對 CPE 課程類別、時數、倫理課程、申報方式及可認列條件可能不同。購買前及選課前，請自行確認本人所屬州別或主管機關之最新 CPE 要求，並依 Becker CPE Catalog 檢查課程是否適用。</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* <!-- PRICE --> */}
            <section class="bk-section bk-section--navy" id="purchase">
                <div class="bk-container bk-price-block">
                    <p class="bk-price-block__label">方案費用</p>
                    <p class="bk-price-block__amount">NT$28,000</p>
                    <p class="bk-price-block__note">含營業稅 &nbsp;｜&nbsp; 一年方案效期</p>
                    <a href="https://www.beckertw.com/registration/plan?parent_id=1" class="bk-price-block__cta" target="_blank">立即購買方案</a>

                    <div class="bk-price-includes">
                        <span class="bk-price-include-item">三次一對一取照諮詢</span>
                        <span class="bk-price-include-item">一次會計師背書媒合協助</span>
                        <span class="bk-price-include-item">Becker CPE Select 一年方案</span>
                    </div>
                </div>
            </section>

            {/* <!-- LINE CTA --> */}
            <section class="bk-section">
                <div class="bk-container">
                    <p class="bk-section__label">聯繫我們</p>
                    <h2 class="bk-section__heading">從通過考試，到取得執業資格</h2>
                    <hr class="bk-divider"/>
                    <p class="bk-section__lead">
                        通過美國 CPA 考試，尚不等於成為執業會計師。各州申請條件、背書要求、文件準備、轉州策略與 CPE 規範，都可能影響你取得正式 Active License 的進度。讓 Becker Taiwan 陪你釐清下一步。
                    </p>

                    <div class="bk-line-banner">
                        <div class="bk-line-banner__text">
                            <strong>有購買前問題？</strong><br/>
                            歡迎透過 LINE 一對一客服諮詢，Becker 團隊將協助你確認方案是否適合你的狀況。
                        </div>
                        <a href="https://page.line.me/vtz1908l?openQrModal=true" class="bk-line-banner__btn" target="_blank"><span className="text-white">LINE 客服諮詢</span></a>
                    </div>
                </div>
            </section>

            {/* <!-- DISCLAIMER --> */}
            <div class="bk-disclaimer">
                <div class="bk-container">
                    <p class="bk-disclaimer__heading">重要提醒</p>
                    <p class="bk-disclaimer__text">
                        Becker Taiwan 提供之諮詢與說明，係依官方公開資訊、官方指定認證單位、官方考試單位、各州發照單位資訊及過往實務經驗，進行一般性說明與經驗分享。本方案不包含代辦服務。所有申請文件之準備、提交、追蹤、補件、繳費、官方往來及最終申請結果，均由購買者自行負責。本方案不保證一定取得背書、一定取得美國 CPA Active License、一定通過官方審查、一定轉州成功、一定抵免台灣會計師考試成功，或特定 CPE 課程一定符合特定州別、年度或主管機關之認列要求。實際執照申請結果仍以美國各州會計師委員會 State Board of Accountancy 及其他相關官方單位之審核為準。若購買頁面、報價單、發票或購買確認信另載優惠價格，則以購買當時所載金額為準。
                    </p>
                </div>
            </div>

        </div>
    </>
  );
}

export default Cpaafter;
